import { PMBFormatDate } from 'helpers'
import DataTable from 'react-data-table-component'
import { ChevronDown, X } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { Modal, ModalBody } from 'reactstrap'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import { setDataMovement, setIsOpenModalDetailMovement } from './detailSlice'

const ModalMovement = () => {
  const dispatch = useDispatch()
  const { isOpenModalDetailMovement, dataMovement } = useSelector(
    (s) => s.catchesDetail,
  )

  const columns = [
    {
      name: <span>Name Spesies</span>,
      cell: (row) => <span>{row?.selectedFish?.nameItem}</span>,
    },
    {
      name: <span>Transhipment Code</span>,
      cell: (row) => <span>{row?.id}</span>,
    },
    {
      name: <span>Berat Bersih</span>,
      cell: (row) => (
        <span>
          {newFormatThousandSeparator(row?.weight)}{' '}
          {row?.selectedFish?.unit || 'kg'}
        </span>
      ),
    },
    {
      name: <span>Waktu Alih Muat</span>,
      cell: (row) => <span>{PMBFormatDate(row?.createdAt)}</span>,
    },
    {
      name: <span>Lokasi Alih Muat/WPP</span>,
      cell: (row) => <span>{row?.fishingArea?.name}</span>,
    },
    {
      name: <span>Koordinat Alih Muatan</span>,
      cell: (row) => (
        <span>
          {row?.latitude}, {row?.longitude}
        </span>
      ),
    },
  ]

  const customStyles = {
    headCells: {
      style: {
        color: '#667085',
        backgroundColor: '#F9FAFB',
      },
    },
    cells: {
      style: {
        marginTop: '1px',
        marginBottom: '1px',
      },
    },
    rows: {
      style: {
        marginTop: '1px',
        marginBottom: '1px',
        '&:hover': {
          backgroundColor: '#F9FAFB',
        },
      },
    },
  }

  const onHandleCloseModal = () => {
    dispatch(setIsOpenModalDetailMovement())
    dispatch(setDataMovement([]))
  }

  return (
    <Modal
      centered
      style={{ maxWidth: '75vw' }}
      keyboard={false}
      isOpen={isOpenModalDetailMovement}
      toggle={() => onHandleCloseModal()}
      data-testid="catches-modal-movement"
    >
      <ModalBody>
        <div className="d-flex justify-content-between my-3">
          <h5>Rincian alih Muatan</h5>
          <X
            size={20}
            onClick={() => onHandleCloseModal()}
            style={{ cursor: 'pointer' }}
            data-testid="catches-modal-movement-close-button"
          />
        </div>
        <DataTable
          customStyles={customStyles}
          columns={columns}
          data={dataMovement || []}
          progressPending={dataMovement?.length === 0}
          responsive
          persistTableHead
          paginationTotalRows={0}
          progressComponent={
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                margin: '100px 0px',
              }}
            >
              {/* <Spinner /> */}
              <p className="my-3 fw-semibold">
                Belum ada daftar rincian alih muatan
              </p>
            </div>
          }
          sortIcon={<ChevronDown />}
          sortServer
          className="border p-0 border-1 rounded-top"
          noDataComponent={
            <p className="my-3 fw-semibold">
              Belum ada daftar rincian alih muatan
            </p>
          }
          // pagination
        />
      </ModalBody>
    </Modal>
  )
}

export default ModalMovement
